export const STEPS = [
  { label: 'Старт онбордингу', icon: '🚀' },
  { label: 'Персональна інформація', icon: '👤' },
  { label: 'Дані ФОП', icon: '🗂' },
  { label: 'Комплаєнс', icon: '🛡' },
  { label: 'Структура діяльності️', icon: '⚙' },
  { label: 'Документи', icon: '📁' },
  { label: 'Страхові компанії', icon: '🛡' },
  { label: 'Договір', icon: '📄' },
  { label: 'Перевірка даних', icon: '🚀' },
  { label: 'Статус', icon: '🏁', optional: 1, },
  { label: 'Підписання', icon: '✍' },
];

export const INSURERS = [
  { code: 'ORANTA', name: 'ПАТ «НАСК «Оранта»' },
  { code: 'ARSENAL', name: 'ПрАТ «СК «Арсенал Страхування»' },
  { code: 'VUSO', name: 'ПрАТ «СК «ВУСО»' },
  { code: 'EXPRESS', name: 'ТДВ «Експрес Страхування»' },
  { code: 'ARX', name: 'АТ «СК «АРКС»' },
  { code: 'UNIQA', name: 'ПрАТ «СК «Уніка»' },
  { code: 'UNIVERSALNA', name: 'ПрАТ «СК «Універсальна»' },
  { code: 'RESPEKT', name: 'ПрАТ «СК «Респект»' },
  { code: 'PERSCHA', name: 'ПрАТ «СК «Перша»' },
  { code: 'ETC', name: 'ПрАТ «СК «Європейське туристичне страхування»' },
  { code: 'EIA', name: 'ПрАТ «ЄСА»' },
  { code: 'EUROINS', name: 'ПрАТ «СК «Євроінс Україна»' },
  { code: 'PZU', name: 'ПрАТ «СК «ПЗУ Україна»' },
  { code: 'INTERPOLIS', name: 'ПрАТ «СК «Інтер-Поліс»' },
  { code: 'GUARDIAN', name: 'ТДВ «СК «Гардіан»' },
  { code: 'TAS', name: 'ПрАТ «СГ «ТАС»' },
  { code: 'KNYAZHA', name: 'ПрАТ «УСК «Княжа Вієнна Іншуранс Груп»' },
  { code: 'INGO', name: 'АТ «СК «ІНГО»' },
  { code: 'INSK', name: 'ПрАТ «ІНСК»' },
  { code: 'UTSC', name: 'ПрАТ «УТСК»' },
  { code: 'BBS', name: 'АТ «СК «ББС Іншуранс»' },
  { code: 'USG', name: 'ПрАТ «СК «УСГ»' },
];

export const DOCUMENTS = [
  { key: 'bank', label: 'Довідка з банку про відкриття рахунку', hint: 'для отримання комісійної винагороди' },
  { key: 'edr', label: 'Витяг з ЄДР (2026 рік) з відкритим КВЕД 66.22' },
  { key: 'tax_system', label: 'Свідоцтво платника єдиного податку або витяг з Реєстру платників єдиного податку', hint: '(якщо ФОП знаходиться на спрощеній системі оподаткування) Замовити: https://cabinet.tax.gov.ua/login\n' +
      'Інструкція: https://youtu.be/FPffv_2TBsg\n' +
      'або\n' +
      'довідка податкової про обрану систему оподаткування та види економічної діяльності (якщо ФОП знаходиться на загальній системі оподаткування' },
  { key: 'tax_debt', label: 'Довідка про відсутність податкового боргу', hint: 'замовити на cabinet.tax.gov.ua' },
  { key: 'passport', label: 'Скан паспорта (сторінки 1–7, 11 з місцем реєстрації)', hint: 'для власників ID-картки: двостороння копія ID-картки + довідка про місце реєстрації' },
  { key: 'ipn', label: 'РНОКПП (ІПН)' },
  { key: 'criminal', label: 'Повна довідка про несудимість', hint: 'дійсна 30 днів (не давніша 5 днів на момент подачі документів)' },
  { key: 'community', label: 'Витяг із реєстру територіальної громади', hint: 'з «Дії» (не давніша 5 днів на момент подачі документів)' },
  { key: 'qualification', label: 'Сертифікат про підготовку та підвищення кваліфікації страхових посередників (ФОП)', hint: 'за наявності' },
];

export const ONBOARDING_TEMPLATES = [
  {
    label: "2_Запевнення_по_застосованим_заходам_впливу_до_страхового_посередника.xlsx",
    path: "templates/onboarding/2_Запевнення_по_застосованим_заходам_впливу_до_страхового_посередника.xlsx"
  },
  {
    label: "3_Запевнення_щодо_відповідності_ділової_репутації.xlsx",
    path: "templates/onboarding/3_Запевнення_щодо_відповідності_ділової_репутації.xlsx"
  },
  {
    label: "4_Зобов'язання_щодо_таємниці_страхування.xlsx",
    path: "templates/onboarding/4_Зобов'язання_щодо_таємниці_страхування.xlsx"
  },
  {
    label: "Д1_ББС.docx",
    path: "templates/onboarding/Д1_ББС.docx"
  },
  {
    label: "Д2_BBC.docx",
    path: "templates/onboarding/Д2_BBC.docx"
  },
  {
    label: "Д4_BBC.docx",
    path: "templates/onboarding/Д4_BBC.docx"
  },
  {
    label: "Д5_ББС.docx",
    path: "templates/onboarding/Д5_ББС.docx"
  },
  {
    label: "Д6_BBC.docx",
    path: "templates/onboarding/Д6_BBC.docx"
  },
  {
    label: "Д7_ББС.docx",
    path: "templates/onboarding/Д7_ББС.docx"
  },
  {
    label: "ДЕКЛАРАЦІЯ.docx",
    path: "templates/onboarding/ДЕКЛАРАЦІЯ.docx"
  },
  {
    label: "Довідка_ФОП_про_відсутність_штатних_працівників_з_реалізації_docx.docx",
    path: "templates/onboarding/Довідка_ФОП_про_відсутність_штатних_працівників_з_реалізації_docx.docx"
  },
  {
    label: "Довідка_ФОП_про_відсутність_штатних_працівників_з_реалізації_ЕКСПРЕС_СТРАХУВАННЯ.docx",
    path: "templates/onboarding/Довідка_ФОП_про_відсутність_штатних_працівників_з_реалізації_ЕКСПРЕС_СТРАХУВАННЯ.docx"
  },
  {
    label: "Довідка_про_заходи_впливу_ФОП.docx",
    path: "templates/onboarding/Довідка_про_заходи_впливу_ФОП.docx"
  },
  {
    label: "Довідка_щодо_вебсайту_ЕКСПРЕС_СТРАХУВАННЯ.docx",
    path: "templates/onboarding/Довідка_щодо_вебсайту_ЕКСПРЕС_СТРАХУВАННЯ.docx"
  },
  {
    label: "Довідка_щодо_вебсайту_ЄТС.docx",
    path: "templates/onboarding/Довідка_щодо_вебсайту_ЄТС.docx"
  },
  {
    label: "Додаток_1 Зобов'язання_Гардіан.docx",
    path: "templates/onboarding/Додаток_1 Зобов'язання_Гардіан.docx"
  },
  {
    label: "Додаток_2_Згода_Гардіан.docx",
    path: "templates/onboarding/Додаток_2_Згода_Гардіан.docx"
  },
  {
    label: "Додаток_3_Запевнення_Гардіан.docx",
    path: "templates/onboarding/Додаток_3_Запевнення_Гардіан.docx"
  },
  {
    label: "Додаток_5_1_Опитувальник_Страхового_посередника_ФОП.docx",
    path: "templates/onboarding/Додаток_5_1_Опитувальник_Страхового_посередника_ФОП.docx"
  },
  {
    label: "Додаток_5_Анкета_ФОП_СК_ТАС.xlsx",
    path: "templates/onboarding/Додаток_5_Анкета_ФОП_СК_ТАС.xlsx"
  },
  {
    label: "Додаток_5_Анкета_ФОП_всі_СК.xlsx",
    path: "templates/onboarding/Додаток_5_Анкета_ФОП_всі_СК.xlsx"
  },
  {
    label: "Запевнення_щодо_ділової_репутації_ЕКСПРЕС_СТРАХУВАННЯ.docx",
    path: "templates/onboarding/Запевнення_щодо_ділової_репутації_ЕКСПРЕС_СТРАХУВАННЯ.docx"
  },
  {
    label: "Згода_на_обробку_персональних_даних_ІНТЕР-ПОЛІС.docx",
    path: "templates/onboarding/Згода_на_обробку_персональних_даних_ІНТЕР-ПОЛІС.docx"
  },
  {
    label: "Зобов'язання_щодо_збереження_таємниці_страхування_ЕКСПРЕС.docx",
    path: "templates/onboarding/Зобов'язання_щодо_збереження_таємниці_страхування_ЕКСПРЕС.docx"
  },
  {
    label: "Зобовязання щодо збереження таємниці страхування_ІНТЕР-ПОЛІС.docx",
    path: "templates/onboarding/Зобовязання щодо збереження таємниці страхування_ІНТЕР-ПОЛІС.docx"
  },
  {
    label: "Лист_щодо_статусу_мультиагента_ІНТЕР-ПОЛІС.docx",
    path: "templates/onboarding/Лист_щодо_статусу_мультиагента_ІНТЕР-ПОЛІС.docx"
  },
  {
    label: "СК_РЕСПЕКТ_Шаблон_загальний_по_субагенту.docx",
    path: "templates/onboarding/СК_РЕСПЕКТ_Шаблон_загальний_по_субагенту.docx"
  },
  {
    label: "Субагентський_договір.docx",
    path: "templates/onboarding/Субагентський_договір.docx"
  }
];

export const COMPLIANCE_TABS = ['Статус і репутація', 'Судимість і санкції', 'НБУ / ПВК-ФТ', 'Навчання'];

// safe: which answer ('yes' | 'no') is the non-blocking one
export const COMPLIANCE = [
  { tab: 0, key: 'c1', q: 'Ви є резидентом РФ або Республіки Білорусь, або пов’язаною з ТОТ України особою?', safe: false, critical: true },
  { tab: 0, key: 'c2', q: 'Ви є публічним діячем (PEP) або пов’язаною з PEP особою?', safe: false },
  { tab: 0, key: 'c3', q: 'Ви маєте повну цивільну дієздатність?', safe: true },
  { tab: 0, key: 'c4', q: 'Ви маєте бездоганну ділову репутацію?', safe: true },
  { tab: 0, key: 'c5', q: 'Вас виключали з Реєстру страхових посередників за останні 3 роки?', safe: false },
  { tab: 0, key: 'c6', q: 'Істотна участь посередника у страховику', safe: false },
  { tab: 0, key: 'c7', q: 'Чи страховик має істотну участь у посереднику', safe: false },

  { tab: 1, key: 'c8', q: 'Непогашена судимість за умисні злочини у сфері господарської діяльності або проти власності?', safe: false, critical: true },
  { tab: 1, key: 'c9', q: 'За останні 5 років ключові функції у фінустанові, до якої застосовувались санкції?', safe: false },
  { tab: 1, key: 'c10', q: 'За останні 10 років керівна роль у фінустанові, що збанкрутіла або втратила ліцензію?', safe: false },
  { tab: 1, key: 'c11', q: 'Включені до санкційних списків або переліків терористів?', safe: false, critical: true },
  { tab: 1, key: 'c12', q: 'Ваш ФОП перебуває у процесі ліквідації або банкрутства?', safe: false },
  { tab: 1, key: 'c13', q: 'Звільнення за останні 5 років за корупцію, шахрайство або аморальні вчинки?', safe: false },

  { tab: 2, key: 'c14', q: 'За останні 10 років застосовувались заходи впливу у сфері ПВК/ФТ?', safe: false },
  { tab: 2, key: 'c15', q: 'НБУ або інший регулятор застосовував до вас заходи впливу?', safe: false },
  { tab: 2, key: 'c16', q: 'Ви надавали недостовірну інформацію НБУ або іншому регулятору?', safe: false },
  { tab: 2, key: 'c17', q: 'Дії, що створюють умови для воєнного чи збройного конфлікту?', safe: false, critical: true },
  { tab: 2, key: 'c18', q: 'Ви дотримуєтесь вимог законодавства у сфері ПВК/ФТ?', safe: true },

  { tab: 3, key: 'c19', q: 'Пройшли навчання страхового посередника та маєте відповідний сертифікат?', safe: true },
];

export const PREP_CHECKLIST = [
  'Паспорт або ID-картка + ІПН',
  'Витяг з ЄДР з КВЕД 66.22',
  'Довідка з банку (IBAN)',
  'Довідка про несудимість',
  'Витяг із реєстру територіальної громади',
  'Сертифікат кваліфікації посередника (за наявності)',
  'Довідка про відсутність податкового боргу',
  'КЕП для підписання',
];

export const MILESTONES = [
  { icon: '👤', label: 'Профіль заповнено' },
  { icon: '📁', label: 'Документи перевірено' },
  { icon: '🔐', label: 'КЕП підтверджено' },
  { icon: '📝', label: 'Договір підписано' },
  { icon: '📤', label: 'Документи передано до СК' },
];
